import styles from './Footer.module.css';

export function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.content}>
        <div className={styles.leftWrapper}>
          <button type="button" className={styles.leftButton}>
            &copy; Aprio One AB 2025
          </button>
          <div className={styles.leftOverlay}>
            <h4>Aprio One AB</h4>
            <p>A Swedish corporation operating under Swedish law.</p>
          </div>
        </div>
        <div className={styles.links}>
          <div className={styles.linkWrapper}>
            <button type="button" className={styles.linkButton}>
              Security
            </button>
            <div className={styles.overlay}>
              <h4>Security</h4>
              <p>
                We implement industry-standard security practices including encryption in transit
                and at rest, regular security audits, and strict access controls.
              </p>
              <p className={styles.copyright}>&copy; Aprio One AB</p>
            </div>
          </div>
          <div className={styles.linkWrapper}>
            <button type="button" className={styles.linkButton}>
              Privacy
            </button>
            <div className={styles.overlay}>
              <h4>Privacy</h4>
              <p>
                We collect minimal data necessary to provide our services. Your data is never sold
                to third parties. You can request deletion of your data at any time.
              </p>
              <p className={styles.copyright}>&copy; Aprio One AB</p>
            </div>
          </div>
          <div className={styles.linkWrapper}>
            <button type="button" className={styles.linkButton}>
              Terms
            </button>
            <div className={styles.overlay}>
              <h4>Terms of Service</h4>
              <p>
                By using hey.sh services, you agree to use them responsibly and in accordance with
                applicable laws. We reserve the right to modify or terminate services at any time.
              </p>
              <p className={styles.copyright}>&copy; Aprio One AB</p>
            </div>
          </div>
        </div>
        <div className={styles.sibling}>
          A sibling surface to{' '}
          <span className={styles.siblingWrapper}>
            <a href="https://aprio.one" target="_blank" rel="noopener noreferrer">
              aprio.one
            </a>
            <span className={styles.siblingOverlay}>
              <h4>aprio.one</h4>
              <p>Priority management and decision-making tools for teams and individuals.</p>
            </span>
          </span>{' '}
          and{' '}
          <span className={styles.siblingWrapper}>
            <a href="https://prio.ai" target="_blank" rel="noopener noreferrer">
              prio.ai
            </a>
            <span className={styles.siblingOverlay}>
              <h4>prio.ai</h4>
              <p>AI-powered prioritization and workflow automation platform.</p>
            </span>
          </span>
        </div>
        <div className={styles.version}>v{__APP_VERSION__}</div>
      </div>
    </footer>
  );
}
